<template>
  <v-toolbar
    :clipped-left="$vuetify.breakpoint.lgAndUp"
    color="blue darken-3"
    dark
    app
    fixed
  >
    <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <span class="hidden-sm-and-down">Colegio Herbart</span>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <!--
    <v-btn icon>
      <v-icon>notifications</v-icon>
    </v-btn>
    -->
    <v-btn icon>
      <v-icon>logout</v-icon>
    </v-btn>
  </v-toolbar>
</template>
<script>
  export default {
    name: "guest",
    data () {
      return {
        drawer: false,
        items: [
          {title: 'Inicio', icon: 'home', to:'/'},
          {title: 'Login', icon: 'forward', to:'/login'},
        ]
      }
    }
  }
</script>
